import React, { useEffect } from 'react';
import { CheckCircle, Close } from '@mui/icons-material';

const AUTO_HIDE_MS = 8000;

/** Deux notes courtes via Web Audio : pas de fichier son à embarquer. */
export const playPaymentChime = () => {
    try {
        const AudioCtx = window.AudioContext || window.webkitAudioContext;
        if (!AudioCtx) return;
        const ctx = new AudioCtx();
        [880, 1320].forEach((freq, i) => {
            const osc = ctx.createOscillator();
            const gain = ctx.createGain();
            const start = ctx.currentTime + i * 0.18;
            osc.frequency.value = freq;
            gain.gain.setValueAtTime(0.0001, start);
            gain.gain.exponentialRampToValueAtTime(0.25, start + 0.02);
            gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.3);
            osc.connect(gain).connect(ctx.destination);
            osc.start(start);
            osc.stop(start + 0.32);
        });
        setTimeout(() => ctx.close(), 1000);
    } catch {
        // Le navigateur peut bloquer l'audio sans interaction préalable : l'alerte visuelle suffit.
    }
};

const PaymentReceivedToast = ({ alert, onClose }) => {
    useEffect(() => {
        if (!alert) return undefined;
        const timer = setTimeout(onClose, AUTO_HIDE_MS);
        return () => clearTimeout(timer);
    }, [alert, onClose]);

    if (!alert) return null;

    return (
        <div className="fixed top-4 right-4 left-4 sm:left-auto z-[100] sm:w-96" role="status" aria-live="polite">
            <div className="flex items-start gap-3 rounded-2xl border border-emerald-200 bg-white p-4 shadow-2xl shadow-emerald-500/10">
                <div className="w-10 h-10 rounded-xl bg-emerald-500 flex items-center justify-center shrink-0">
                    <CheckCircle className="text-white" />
                </div>
                <div className="flex-1 min-w-0">
                    <p className="text-sm font-bold text-slate-900">{alert.title}</p>
                    {alert.message && <p className="text-sm text-slate-600 mt-0.5">{alert.message}</p>}
                </div>
                <button
                    type="button"
                    onClick={onClose}
                    className="p-1 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100"
                    aria-label="Fermer"
                >
                    <Close sx={{ fontSize: 18 }} />
                </button>
            </div>
        </div>
    );
};

export default PaymentReceivedToast;
